import { render } from "./TryRotate.vue?vue&type=template&id=626f642a"
import script from "./TryRotate.vue?vue&type=script&lang=js"
export * from "./TryRotate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__